import './styles.scss';
import { formatPrice } from 'utils/formatters';
import ShopifyLogo from 'assets/images/shopify-logo.webp';
import { ShopifyProduct } from '../../../../../../app/graphql/generated/cart/graphql';
import { MAX_PRODUCT_DESCRIPTION_LENGTH } from '../../const';
import { truncateText } from 'lib/utils';

const DEFAULT_QUANTITY = 1;

interface ItemCatalogCardValue {
  variantId: string;
  quantity: number;
  productId?: string;
  price?: number | null;
  currency: string | undefined;
  product: ShopifyProduct | undefined;
}

export const ShopifyItemCatalogCard = (props: ItemCatalogCardValue) => {
  const shopifyProduct = props.product;
  const productUrl = shopifyProduct ? shopifyProduct.storeCanonicalURL + shopifyProduct.url : null;

  const imageUrl = shopifyProduct?.images?.length ? shopifyProduct.images[0].url : ShopifyLogo;

  return (
    <tr>
      <td>
        <img className="item-catalog-product-image" alt={shopifyProduct?.title} src={imageUrl} />
      </td>
      <td>
        <div className="item-catalog-product-description">
          <div className="item-catalog-product-description-row">
            {shopifyProduct ? (
              <>
                <b>Name</b>
                <div>{shopifyProduct.title}</div>
              </>
            ) : (
              <>
                <b>ID</b>
                <div>{props.variantId} (data unavailable)</div>
              </>
            )}
          </div>{' '}
          {shopifyProduct && (
            <>
              <div className="item-catalog-product-description-row">
                <b>Variant</b>
                <div>
                  {shopifyProduct.variants.find(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (v: any) => v.__typename === 'ShopifyVariant' && v.id === props.variantId,
                  )?.title ?? 'Unknown'}
                </div>
              </div>
              {shopifyProduct?.description && (
                <div className="item-catalog-product-description-row">
                  <b>Description</b>
                  <div>
                    {truncateText(shopifyProduct.description, MAX_PRODUCT_DESCRIPTION_LENGTH)}
                  </div>
                </div>
              )}
            </>
          )}
          {productUrl && (
            <div className="item-catalog-product-description-row">
              <b>Product Link</b>
              <div>
                <a href={productUrl} target="_blank" rel="noreferrer">
                  {productUrl}
                </a>
              </div>
            </div>
          )}
        </div>
      </td>
      <td>{props.quantity ?? DEFAULT_QUANTITY}</td>
      <td>
        {props.price != null && props.currency
          ? formatPrice(props.price / 100, props.currency)
          : shopifyProduct?.price?.displayValue ?? 'N/A'}
      </td>
    </tr>
  );
};
